import { Modal } from "@enxcs/dap-ui-stratos";
import styled, { css } from "styled-components";

export const ModalStyled = styled(Modal).withConfig({
  shouldForwardProp: (prop) => !["isBeforeRecording"].includes(prop),
})<{ isBeforeRecording: boolean }>`
  & [role="dialog"] {
    max-width: 840px !important;
    ${({ isBeforeRecording }) =>
      !isBeforeRecording &&
      css`
        width: 840px !important;
      `}
    border-radius: 4px !important;
    max-height: 596px !important;
  }
  & [role="dialog"] > div:nth-of-type(2) {
    overflow-y: hidden !important;
  }
`;
